import { Color } from '@diritto/common/style/color';
import { IconProps } from '@diritto/common/style/icon';

export const CheckIcon = ({ size = 10, color = Color.White }: IconProps) => (
  <svg width={size} height={(size * 8) / 10} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.725 7.22505L0.625 4.12505L1.475 3.27505L3.725 5.52505L8.5125 0.737549L9.3625 1.58755L3.725 7.22505Z"
      fill={color}
    />
  </svg>
);
